module.exports = __webpack_public_path__ + "img/microplastics-7.97c8689b.png";